import { UpdateConsultationDto } from '@/core/models/consultation.model'
import { useGetConsultationQuery } from '@/core/services/consultation'
import { WithId } from '@/core/types/shared'
import { skipToken } from '@reduxjs/toolkit/query'
import { useEffect } from 'react'

type UseAutoRecordingProps = {
  consultationId: string
  isRecording: boolean
  isDoctor: boolean
  handleStartRecording: () => void
  updateConsultation: (consultation: WithId<{ changes: UpdateConsultationDto }>) => void
}

const useAutoRecording = ({ consultationId, isRecording, isDoctor, handleStartRecording, updateConsultation }: UseAutoRecordingProps) => {
  const { data: consultation } = useGetConsultationQuery(consultationId ?? skipToken)
  const autoRecording = consultation?.autoRecording

  useEffect(() => {
    if (autoRecording && !isRecording && isDoctor) {
      handleStartRecording()
      updateConsultation({
        id: consultationId,
        changes: {
          autoRecording: false,
        },
      })
    }
  }, [autoRecording, isRecording, consultationId, updateConsultation, isDoctor, handleStartRecording])
}

export default useAutoRecording
